import {
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

const TenantSelect = ({
  label,
  labelId,
  value,
  onChange,
  children,
  size = "small",
  sx = {},
  ...props
}) => {
  const resolvedLabelId =
    labelId || `${label?.toLowerCase().replace(/\s+/g, "-")}-label`;

  return (
    <FormControl
      size={size}
      sx={{
  minWidth: 220,

  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "var(--tenant-primary)",
    },

    "&:hover fieldset": {
      borderColor: "var(--tenant-secondary)",
    },

    "&.Mui-focused fieldset": {
      borderColor: "var(--tenant-secondary) !important",
    },
  },

  "& .MuiInputLabel-root": {
    color: "var(--tenant-primary)",
  },

  "& .MuiInputLabel-root.Mui-focused": {
    color: "var(--tenant-secondary) !important",
  },

  "& .MuiSelect-select": {
    color: "var(--tenant-primary)",
  },

  "& .MuiSvgIcon-root": {
    color: "var(--tenant-primary)",
  },

  ...sx,
}}
    >
      <InputLabel id={resolvedLabelId}>{label}</InputLabel>

      <Select
        labelId={resolvedLabelId}
        value={value}
        label={label}
        onChange={onChange}
        {...props}
      >
        {children}
      </Select>
    </FormControl>
  );
};

export default TenantSelect;